import $dom from 'cash-dom';

const toggleRecipeSteps = () => {
  const expandButton = $dom('.js-expand-recipe');
  const collapseButton = $dom('.js-collapse-recipe');

  expandButton.on('click', e => {
    e.preventDefault();

    $dom('.js-recipe-steps-section')
      .removeClass('collapsed')
      .addClass('expanded');

    expandButton.addClass('hidden');
    collapseButton.removeClass('hidden');
  });

  collapseButton.on('click', e => {
    e.preventDefault();

    $dom('.js-recipe-steps-section')
      .removeClass('expanded')
      .addClass('collapsed');

    expandButton.removeClass('hidden');
    collapseButton.addClass('hidden');
  });
};

export default toggleRecipeSteps;
